import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteProcurement } from "../../services/procurement";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function ProcurementDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Procurement ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/procurement/list");
  };

  return (
    <Confirm
      header={locale.get("procurement.confirmDelete")}
      loading={loading}
      onClose={closeModal}
      onConfirm={() => {
        (async () => {
          setLoading(true);
          try {
            await deleteProcurement(id);
            await Promise.all([
              queryClient.invalidateQueries({ queryKey: ["procurements"] }),
              queryClient.invalidateQueries({ queryKey: ["procurement", id] }),
            ]);
          } finally {
            setLoading(false);
            closeModal();
          }
        })();
      }}
    />
  );
}
